(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_rr_filter_tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    // 絞り込みタブ：同じ箱（セクション）の中の商品カードを、カードの印（data-rr-tags）で出し分ける。
    const HIDDEN = 'data-rr-filter-hidden';
    const norm = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    const hasTag = (item, tag) => {
      const target = norm(tag);
      if (!target) return true;
      const tags = ' ' + norm(item.getAttribute('data-rr-tags')) + ' ';
      return tags.indexOf(' ' + target + ' ') !== -1;
    };
    const setHidden = (element, hide) => {
      if (!element) return;
      if (hide) {
        element.setAttribute(HIDDEN, '');
      } else {
        element.removeAttribute(HIDDEN);
      }
    };
    // ブロックは <div class="shopify-block"> に包まれて出るので、隠すときは包みごと隠す
    const wrapperOf = (element) => {
      const parent = element && element.parentElement;
      return parent && parent.classList.contains('shopify-block') ? parent : element;
    };
    // URLの # の後ろ（デコード済み）。取れなければ空文字
    const rawHash = () => {
      const raw = window.location.hash.replace(/^#/, '');
      try {
        return decodeURIComponent(raw);
      } catch (error) {
        return raw;
      }
    };

    const initFilterTabs = (bar) => {
      if (bar.dataset.rrFilterInit) return;
      bar.dataset.rrFilterInit = '1';

      const root = bar.closest('.rr-canvas') || bar.closest('.shopify-section') || document;
      const buttons = Array.from(bar.querySelectorAll('[data-rr-filter-key]'));
      if (!buttons.length) return;
      // 印が空のタブ＝「全部」
      const allButton = buttons.find((button) => !norm(button.getAttribute('data-rr-filter-tag'))) || null;
      // 絞り込み中の見せ方：stages＝段ごと（従来）／merged＝1つの一覧にまとめる（WO-091）
      const mergedMode = bar.getAttribute('data-rr-filter-layout') === 'merged';
      const barWrapper = wrapperOf(bar);
      let merged = null;
      const removeMerged = () => {
        if (merged && merged.parentNode) merged.parentNode.removeChild(merged);
        merged = null;
      };
      // 写し（クローン）から、ページ内で一意であるべき印（id・エディター用の属性）を外す
      const stripIds = (element) => {
        element.removeAttribute('id');
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name.indexOf('data-shopify-editor') === 0) element.removeAttribute(attribute.name);
        });
      };

      // button が null のときは、どのタブも選ばずに全部を表示する
      const apply = (button) => {
        buttons.forEach((candidate) => {
          const isActive = candidate === button;
          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const tag = button ? button.getAttribute('data-rr-filter-tag') || '' : '';
        removeMerged();
        const stages = new Map();
        const grids = [];
        const shownItems = [];
        root.querySelectorAll('.rr-product-grid').forEach((grid) => {
          let shown = 0;
          grids.push(grid);
          Array.from(grid.children).forEach((item) => {
            if (!item.classList.contains('rr-product-grid__item')) return;
            // 品目別のカードは、印が一致するタブでだけ出す（「全部」では出さない）
            const isVariantCard = item.hasAttribute('data-rr-variant-card');
            const match = norm(tag) ? hasTag(item, tag) : !isVariantCard;
            if (match) shownItems.push(item);
            setHidden(item, !match);
            if (match) shown += 1;
          });

          const gridRoot = grid.closest('.rr-product-grid-carousel') || grid;
          setHidden(wrapperOf(gridRoot), shown === 0);

          // 段＝グリッドを包んでいる一番近いコンテナー（_rr_box）。タブ自身を含む袋は段として扱わない
          const stage = gridRoot.parentElement ? gridRoot.parentElement.closest('.rr-box') : null;
          if (stage && root.contains(stage) && !stage.contains(bar)) {
            stages.set(stage, (stages.get(stage) || 0) + shown);
          }
        });

        stages.forEach((count, stage) => {
          setHidden(wrapperOf(stage), count === 0);
        });

        // 1つの一覧にまとめる（全部以外のタブのとき）
        if (!mergedMode || !norm(tag) || !grids.length) return;

        const firstGrid = grids[0];
        const firstGridRoot = firstGrid.closest('.rr-product-grid-carousel') || firstGrid;
        const firstStage = firstGridRoot.parentElement ? firstGridRoot.parentElement.closest('.rr-box') : null;
        const useStage = firstStage && root.contains(firstStage) && !firstStage.contains(bar);

        // 段（見出し・線・説明文ごと）とグリッドをすべて隠す
        grids.forEach((grid) => {
          const gridRoot = grid.closest('.rr-product-grid-carousel') || grid;
          setHidden(wrapperOf(gridRoot), true);
        });
        stages.forEach((count, stage) => {
          setHidden(wrapperOf(stage), true);
        });

        // ページ上の順に、同じ商品（品目別カードは品目ごと）は1回だけ
        const seen = new Set();
        const list = firstGrid.cloneNode(false);
        stripIds(list);
        list.classList.remove('rr-product-grid--carousel');
        // 見出しとの間の上マージンは見出しを隠すと意味が無くなるので 0（段の上の余白とタブの下マージンは残る）
        list.style.marginTop = '0px';
        shownItems.forEach((item) => {
          const key = (item.getAttribute('data-rr-handle') || '') + '|' + (item.getAttribute('data-rr-variant-id') || '');
          if (seen.has(key)) return;
          seen.add(key);
          const copy = item.cloneNode(true);
          copy.removeAttribute(HIDDEN);
          copy.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          list.appendChild(copy);
        });

        // 一覧の器：最初の段と同じ余白の箱（見出しなし）に入れる
        merged = document.createElement('div');
        merged.className = 'shopify-block rr-filter-merged';
        merged.setAttribute('data-rr-filter-merged', '');
        let holder = merged;
        if (useStage) {
          const shell = firstStage.cloneNode(false);
          stripIds(shell);
          shell.removeAttribute('data-rr-view');
          const innerSource = firstStage.querySelector(':scope > .rr-box__inner');
          const inner = innerSource ? innerSource.cloneNode(false) : document.createElement('div');
          stripIds(inner);
          shell.appendChild(inner);
          merged.appendChild(shell);
          holder = inner;
        }
        const listWrapper = document.createElement('div');
        listWrapper.className = 'shopify-block';
        listWrapper.appendChild(list);
        holder.appendChild(listWrapper);

        const anchor = useStage ? wrapperOf(firstStage) : wrapperOf(firstGridRoot);
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(merged, anchor);
        } else if (barWrapper && barWrapper.parentNode) {
          barWrapper.parentNode.insertBefore(merged, barWrapper.nextSibling);
        }
      };

      // URLの # を読んで反映する。
      // ・# がタブの名前（#leaf・#gift など）→ そのタブで絞り込む
      // ・# が段の行き先（#original・#set など）で、その段が絞り込みで隠れている → 「全部」に戻す
      // ・絞り込みで並びが動くので、行き先の要素があれば最後にそこへ移動し直す
      // 1つの一覧にまとめる見せ方では、段の行き先（#gift など）がタブの名前と同じでも段への移動を優先する。
      // そのためタブの # は、同じ名前の段があるときだけ「filter-」を頭に付けて書く（例 #filter-gift）。WO-091
      const FILTER_PREFIX = 'filter-';
      const stageAnchor = (id) => {
        if (!mergedMode || !id) return null;
        const target = document.getElementById(id);
        return target && root.contains(target) && !target.contains(bar) ? target : null;
      };
      const hashKeyOf = (key) => (stageAnchor(key) ? FILTER_PREFIX + key : key);

      const applyHash = () => {
        const raw = rawHash();
        if (!raw) return false;
        let key = norm(raw);
        const prefixed = key.indexOf(FILTER_PREFIX) === 0;
        if (prefixed) key = key.slice(FILTER_PREFIX.length);
        let button = buttons.find((candidate) => candidate.getAttribute('data-rr-filter-key') === key) || null;
        const target = prefixed ? null : document.getElementById(raw);
        if (!prefixed && stageAnchor(raw)) button = null;
        if (button) {
          apply(button);
        } else if (target && root.contains(target) && target.closest('[' + HIDDEN + ']')) {
          apply(allButton);
        } else {
          return false;
        }
        if (target && !target.closest('[' + HIDDEN + ']')) {
          target.scrollIntoView({ block: 'start' });
        }
        return true;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          apply(button);
          const key = button.getAttribute('data-rr-filter-key') || '';
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + encodeURIComponent(hashKeyOf(key)));
          }
        });
      });

      window.addEventListener('hashchange', applyHash);

      // ヘッダーのなめらか移動（sections/header.liquid）は URL の # を先に消してから動くので、
      // 移動直前の合図（rr:anchor-before-scroll）を受けて表示を整える。
      document.addEventListener('rr:anchor-before-scroll', (event) => {
        const id = event.detail && event.detail.id ? String(event.detail.id) : '';
        if (!id) return;
        const button = buttons.find((candidate) => candidate.getAttribute('data-rr-filter-key') === norm(id)) || null;
        const target = document.getElementById(id);
        if (stageAnchor(id)) {
          // まとめた一覧の見せ方：メニューの小見出しから来たら「全部」に戻してからその段へ
          apply(allButton);
        } else if (button) {
          apply(button);
        } else if (target && root.contains(target) && target.closest('[' + HIDDEN + ']')) {
          apply(allButton);
        }
      });

      // ページ内リンク（メニューなど）で、絞り込みで隠れている段へ移動しようとしたら、先に「全部」に戻す。
      // ヘッダーのなめらか移動（sections/header.liquid）より先に動くよう、捕捉段階で受け取る。
      window.addEventListener('click', (event) => {
        const link = event.target && event.target.closest ? event.target.closest('a[href*="#"]') : null;
        if (!link) return;
        let url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (error) {
          return;
        }
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        let id = url.hash.replace(/^#/, '');
        try {
          id = decodeURIComponent(id);
        } catch (error) {
          // そのまま使う
        }
        if (!id) return;
        const target = document.getElementById(id);
        if (target && root.contains(target) && target.closest('[' + HIDDEN + ']')) {
          apply(allButton);
        }
      }, true);

      if (!applyHash()) {
        apply(allButton || buttons[0]);
      }
    };

    const initAll = () => document.querySelectorAll('[data-rr-filter-tabs]').forEach(initFilterTabs);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_form_field"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncResponsivePlaceholders = () => {
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('.rr-form-field__input[data-placeholder-sp], .rr-form-field__textarea[data-placeholder-sp]').forEach((field) => {
        const desktop = field.getAttribute('placeholder') || '';
        if (!field.dataset.placeholderPc) field.dataset.placeholderPc = desktop;
        field.setAttribute('placeholder', mobile ? field.dataset.placeholderSp : field.dataset.placeholderPc);
      });
    };
    syncResponsivePlaceholders();
    window.addEventListener('resize', syncResponsivePlaceholders, { passive: true });
    document.addEventListener('shopify:section:load', syncResponsivePlaceholders);
    document.addEventListener('shopify:block:select', syncResponsivePlaceholders);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_hero_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const SP_QUERY = '(max-width: 749px)';
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 高さ合わせの道具（ふつうは部品内の小さなJSが先に用意している。無い時だけ同じ計算をここで用意する） */
    const firstView = () => {
      if (window.__rrHeroFirstView) return window.__rrHeroFirstView;
      const H = {
        measure(root) {
          if (!root || !root.isConnected) return;
          const top = root.getBoundingClientRect().top + (window.pageYOffset || 0);
          const vh = window.innerHeight || 0;
          const off = top > 0 && top < vh ? top : 0;
          root.style.setProperty('--rr-first-view-offset', `${Math.round(off * 100) / 100}px`);
        },
        measureAll() {
          document.querySelectorAll('[data-rr-hero-slider]').forEach((root) => H.measure(root));
        }
      };
      window.__rrHeroFirstView = H;
      window.addEventListener('resize', () => H.measureAll());
      return H;
    };

    const initSlider = (root) => {
      if (!root || root.dataset.rrHeroInit === '1') return;
      const track = root.querySelector(':scope > .rr-hero-slider__track');
      if (!track) return;
      root.dataset.rrHeroInit = '1';
      firstView().measure(root);

      const dotsBox = root.querySelector(':scope > .rr-hero-slider__dots');
      const prevBtn = root.querySelector(':scope > .rr-hero-slider__arrow--prev');
      const nextBtn = root.querySelector(':scope > .rr-hero-slider__arrow--next');
      const speedValue = parseFloat(root.dataset.speed);
      const cfg = {
        autoplay: root.dataset.autoplay === 'true',
        speed: (Number.isFinite(speedValue) ? Math.max(0, speedValue) : 0) * 1000,
        loop: root.dataset.loop === 'true',
        pauseHover: root.dataset.pauseHover === 'true',
        effect: root.dataset.effect === 'slide' ? 'slide' : 'fade',
        dotLabel: root.dataset.dotLabel || ''
      };
      const intervalMs = () => {
        const seconds = parseFloat(window.matchMedia(SP_QUERY).matches ? root.dataset.intervalSp : root.dataset.interval);
        return (Number.isFinite(seconds) && seconds > 0 ? seconds : 4) * 1000;
      };
      const slides = () => [...track.children].filter((el) => el.classList.contains('shopify-block'));

      let current = 0;
      let timer = null;
      let cleanup = null;
      let moving = false;
      let hovering = false;
      let visible = true;
      let editing = false;

      const updateUi = () => {
        const list = slides();
        list.forEach((el, i) => {
          el.setAttribute('role', 'group');
          el.setAttribute('aria-roledescription', 'slide');
          el.setAttribute('aria-label', `${i + 1} / ${list.length}`);
          el.setAttribute('aria-hidden', i === current ? 'false' : 'true');
        });
        if (dotsBox) {
          [...dotsBox.children].forEach((dot, i) => {
            const on = i === current;
            dot.classList.toggle('is-active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      };

      const finish = () => {
        moving = false;
        root.classList.remove('is-moving');
        slides().forEach((el, i) => {
          if (i !== current) el.classList.remove('is-prev', 'is-from-left');
        });
      };

      const show = (index, opts = {}) => {
        const list = slides();
        const n = list.length;
        if (!n) return;
        let next = index;
        if (next < 0) next = cfg.loop ? n - 1 : 0;
        if (next > n - 1) next = cfg.loop ? 0 : n - 1;
        const incoming = list[next];
        if (next === current && incoming.classList.contains('is-active')) return;
        const outgoing = list[current];
        const back = typeof opts.back === 'boolean' ? opts.back : next < current;
        const instant = opts.instant || cfg.speed === 0 || reduceMotion();

        clearTimeout(cleanup);
        list.forEach((el) => {
          if (el !== incoming && el !== outgoing) el.classList.remove('is-active', 'is-prev', 'is-from-left');
        });
        root.classList.toggle('is-back', back);
        if (instant) root.classList.add('is-instant');

        /* 入ってくる1枚：一度クラスを外して描き直す＝写真の拡大を最初からやり直す。横めくりの「左から」は開始位置を先に置く */
        incoming.classList.remove('is-active', 'is-prev');
        if (cfg.effect === 'slide' && back) incoming.classList.add('is-from-left');
        void incoming.offsetWidth;

        if (outgoing && outgoing !== incoming) {
          outgoing.classList.remove('is-active');
          outgoing.classList.add('is-prev');
        }
        incoming.classList.add('is-active');
        incoming.classList.remove('is-from-left');
        current = next;
        updateUi();

        if (instant) {
          finish();
          requestAnimationFrame(() => root.classList.remove('is-instant'));
        } else {
          moving = true;
          root.classList.add('is-moving');
          cleanup = setTimeout(finish, cfg.speed + 60);
        }
      };

      /* 自動めくり：めくり終わってから「待ち時間」だけ止まり、次へ（SWELL＝journal と同じ数え方） */
      const stopAuto = () => {
        clearTimeout(timer);
        timer = null;
      };
      const scheduleAuto = () => {
        stopAuto();
        if (!cfg.autoplay || editing || reduceMotion() || slides().length < 2) return;
        timer = setTimeout(tick, intervalMs() + (moving ? cfg.speed : 0));
      };
      const tick = () => {
        if (!root.isConnected) {
          stopAuto();
          return;
        }
        if (hovering || !visible || document.hidden) {
          scheduleAuto();
          return;
        }
        if (!cfg.loop && current >= slides().length - 1) {
          stopAuto();
          return;
        }
        show(current + 1, { back: false });
        scheduleAuto();
      };

      const buildDots = () => {
        const list = slides();
        if (dotsBox) {
          dotsBox.innerHTML = '';
          list.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'rr-hero-slider__dot';
            dot.setAttribute('aria-label', `${cfg.dotLabel} ${i + 1}`.trim());
            dot.addEventListener('click', () => {
              show(i);
              scheduleAuto();
            });
            dotsBox.append(dot);
          });
          dotsBox.hidden = list.length < 2;
        }
        if (prevBtn) prevBtn.hidden = list.length < 2;
        if (nextBtn) nextBtn.hidden = list.length < 2;
        updateUi();
      };

      if (prevBtn) prevBtn.addEventListener('click', () => { show(current - 1, { back: true }); scheduleAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { show(current + 1, { back: false }); scheduleAuto(); });

      /* スマホの指でのめくり（横に40px以上はらったら） */
      let sx = null;
      let sy = null;
      track.addEventListener('touchstart', (e) => {
        const t = e.touches[0];
        sx = t.clientX;
        sy = t.clientY;
      }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - sx;
        const dy = t.clientY - sy;
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          show(current + (dx < 0 ? 1 : -1), { back: dx > 0 });
          scheduleAuto();
        }
      }, { passive: true });

      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { show(current - 1, { back: true }); scheduleAuto(); }
        if (e.key === 'ArrowRight') { show(current + 1, { back: false }); scheduleAuto(); }
      });

      if (cfg.pauseHover) {
        root.addEventListener('mouseenter', () => { hovering = true; });
        root.addEventListener('mouseleave', () => { hovering = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(root);
      }

      /* テーマエディタ：スライドの中の部品を選んだら、その1枚を表示して自動めくりを止める */
      root.rrHeroSelect = (target) => {
        const slide = target && target.closest ? target.closest('.rr-hero-slider__track > .shopify-block') : null;
        if (!slide || slide.parentElement !== track) return false;
        const index = slides().indexOf(slide);
        if (index < 0) return false;
        editing = true;
        stopAuto();
        show(index, { instant: true });
        return true;
      };
      root.rrHeroDeselect = () => {
        editing = false;
        scheduleAuto();
      };

      const list = slides();
      list.forEach((el, i) => el.classList.toggle('is-active', i === 0));
      current = 0;
      root.classList.add('is-ready');
      buildDots();
      scheduleAuto();
    };

    const initAll = () => {
      document.querySelectorAll('[data-rr-hero-slider]').forEach(initSlider);
      firstView().measureAll();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', (e) => {
      document.querySelectorAll('[data-rr-hero-slider]').forEach((root) => {
        if (root.contains(e.target) && typeof root.rrHeroSelect === 'function') root.rrHeroSelect(e.target);
      });
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      document.querySelectorAll('[data-rr-hero-slider]').forEach((root) => {
        if (root.contains(e.target) && typeof root.rrHeroDeselect === 'function') root.rrHeroDeselect();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_info_bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    /* 複製を作る：読み上げ・キー操作の対象外にし、id・エディター用の印・style/script は外す */
    const makeClone = (group) => {
      const c = group.cloneNode(true);
      c.classList.add('rr-info-bar__group--clone');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      c.querySelectorAll('style,script').forEach((n) => n.remove());
      [c, ...c.querySelectorAll('*')].forEach((el) => {
        el.removeAttribute('id');
        el.removeAttribute('data-shopify-editor-block');
      });
      c.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
      return c;
    };

    const isCta = (el) => el.nodeType === 1 && (el.matches('.rr-button-wrap') || !!el.querySelector(':scope > .rr-button-wrap'));

    const setup = (root) => {
      if (!root || root.__rrIb || root.dataset.motion !== 'marquee') return;
      const inner = root.querySelector(':scope > .rr-info-bar__inner');
      const viewport = inner && inner.querySelector(':scope > .rr-info-bar__viewport');
      const track = viewport && viewport.querySelector(':scope > .rr-info-bar__track');
      const group = track && track.querySelector(':scope > .rr-info-bar__group');
      const aside = inner && inner.querySelector(':scope > .rr-info-bar__aside');
      if (!group) return;
      const st = (root.__rrIb = { built: null, queued: false });
      const speedValue = parseFloat(root.dataset.speed);
      const speed = Number.isFinite(speedValue) && speedValue > 0 ? speedValue : 50;
      const ctaFixed = root.dataset.cta !== 'flow';
      [...group.children].forEach((el, i) => { el.dataset.rrIbIndex = String(i); });

      /* ボタンの置き場：右端に固定のときは帯の右端（__aside）へ。動きを減らす端末では文の横に戻す */
      const placeCta = (fixed) => {
        if (!aside) return;
        if (fixed) {
          [...group.children].forEach((el) => { if (isCta(el)) aside.append(el); });
        } else if (aside.children.length) {
          [...aside.children].forEach((el) => {
            const idx = Number(el.dataset.rrIbIndex);
            const after = [...group.children].find((g) => Number(g.dataset.rrIbIndex) > idx);
            group.insertBefore(el, after || null);
          });
        }
      };

      const clear = () => {
        track.querySelectorAll(':scope > .rr-info-bar__group--clone').forEach((n) => n.remove());
        root.classList.remove('is-running', 'is-reverse');
      };

      /* 1周ぶんの幅（文＋文と文の間隔）を測り、画面を覆えるだけ複製して偶数個にする。秒数＝距離÷速さ。
         測り直し（文字の読み込み完了・画面の幅の変化）のときは、それまでに進んだ距離から続きを流す（最初に戻さない） */
      const fill = () => {
        st.queued = false;
        let movedPx = 0;
        const anim = track.getAnimations ? track.getAnimations()[0] : null;
        if (anim && st.built && typeof anim.currentTime === 'number') {
          const loopMs = ((st.built.half * st.built.cycleRaw) / speed) * 1000;
          if (loopMs > 0) movedPx = ((anim.currentTime % loopMs) / 1000) * speed;
        }
        clear();
        if (RM.matches) {
          placeCta(false);
          group.style.paddingRight = '';
          st.built = null;
          return;
        }
        placeCta(ctaFixed);
        /* 1周の幅を整数pxに揃える（複製の置き場所が画素の境目に乗り、継ぎ目で文字のにじみ方まで同じになる） */
        group.style.paddingRight = '';
        const natural = group.getBoundingClientRect().width;
        const extra = Math.ceil(natural - 0.001) - natural;
        if (extra > 0.0005) group.style.paddingRight = `${parseFloat(getComputedStyle(group).paddingRight) + extra}px`;
        const cycle = group.getBoundingClientRect().width;
        const vw = viewport.getBoundingClientRect().width;
        if (!(cycle > 0) || !(vw > 0)) return;
        const half = Math.max(1, Math.ceil(vw / cycle));
        const frag = document.createDocumentFragment();
        for (let i = 1; i < half * 2; i += 1) frag.append(makeClone(group));
        track.append(frag);
        const loopSec = (half * cycle) / speed;
        root.style.setProperty('--rr-ib-duration', `${loopSec.toFixed(3)}s`);
        root.style.setProperty('--rr-ib-delay', `${(-((movedPx / speed) % loopSec)).toFixed(3)}s`);
        root.classList.toggle('is-reverse', root.dataset.direction === 'right');
        root.classList.add('is-running');
        st.built = { cycle: Math.round(cycle * 100), vw: Math.round(vw * 100), half, cycleRaw: cycle };
      };

      const queue = () => {
        if (st.queued) return;
        st.queued = true;
        requestAnimationFrame(() => {
          if (!root.isConnected) return;
          const cycle = Math.round(group.getBoundingClientRect().width * 100);
          const vw = Math.round(viewport.getBoundingClientRect().width * 100);
          if (st.built && st.built.cycle === cycle && st.built.vw === vw) {
            st.queued = false;
            return;
          }
          fill();
        });
      };

      fill();
      if ('ResizeObserver' in window) {
        st.ro = new ResizeObserver(queue);
        st.ro.observe(viewport);
        st.ro.observe(group);
      } else {
        window.addEventListener('resize', queue);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
      const onMotion = () => fill();
      if (RM.addEventListener) RM.addEventListener('change', onMotion);
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-rr-info-bar][data-motion="marquee"]').forEach(setup);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));

    /* テーマエディター：帯の中を選んでいる間は止めて、元の文（1つ目）を左端に出す */
    document.addEventListener('shopify:block:select', (e) => {
      const root = e.target && e.target.closest ? e.target.closest('[data-rr-info-bar]') : null;
      if (root) root.classList.add('is-editing');
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const root = e.target && e.target.closest ? e.target.closest('[data-rr-info-bar]') : null;
      if (root) root.classList.remove('is-editing');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_media_magazine_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.rrMediaInit || typeof Swiper === 'undefined') return;
      root.dataset.rrMediaInit = '1';
      new Swiper(root.querySelector('.rr-media-magazine-slider__swiper'), {
        slideClass: 'shopify-block',
        loop: root.dataset.loop === 'true',
        slidesPerView: Number(root.dataset.perSp),
        spaceBetween: Number(root.dataset.gapSp),
        slidesPerGroup: 1,
        centeredSlides: root.dataset.centered === 'true',
        speed: root.dataset.noAnimation === 'true' ? 0 : Number(root.dataset.speed),
        ...(root.dataset.autoplay === 'true'
          ? { autoplay: { delay: Number(root.dataset.delaySp), disableOnInteraction: root.dataset.stopOnTouch === 'true' } }
          : {}),
        breakpoints: {
          768: {
            slidesPerView: Number(root.dataset.per),
            spaceBetween: Number(root.dataset.gap),
            ...(root.dataset.autoplay === 'true'
              ? { autoplay: { delay: Number(root.dataset.delay), disableOnInteraction: root.dataset.stopOnTouch === 'true' } }
              : {})
          }
        }
      });
    };

    const initAll = () => {
      const roots = [...document.querySelectorAll('.rr-media-magazine-slider')];
      if (!roots.length) return;
      if (typeof Swiper !== 'undefined') {
        roots.forEach(init);
        return;
      }
      const existing = document.querySelector('script[data-rr-media-swiper]');
      if (existing) {
        existing.addEventListener('load', () => roots.forEach(init), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = roots[0].dataset.swiperUrl;
      script.dataset.rrMediaSwiper = 'true';
      script.addEventListener('load', () => roots.forEach(init), { once: true });
      document.head.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_product_grid"] && !Shopify.designMode) return;
  try {
    (() => {
    const initProductCarousel = (carousel) => {
      if (carousel.dataset.rrProductCarouselInit) return;
      carousel.dataset.rrProductCarouselInit = '1';

      const track = carousel.querySelector('.rr-product-grid--carousel');
      const dotsBox = carousel.querySelector('.rr-product-grid__dots');
      const previous = carousel.querySelector('.rr-product-grid__arrow--prev');
      const next = carousel.querySelector('.rr-product-grid__arrow--next');
      if (!track || !previous || !next) return;

      const config = {
        autoplay: carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        interval: (parseFloat(carousel.dataset.interval) || 3) * 1000,
        speed: (parseFloat(carousel.dataset.speed) || 0.6) * 1000,
        loop: carousel.dataset.loop === 'true',
        pauseHover: carousel.dataset.pauseHover === 'true'
      };
      const slides = () => [...track.children];
      const step = () => {
        const items = slides();
        if (items.length < 2) return track.clientWidth;
        return items[1].offsetLeft - items[0].offsetLeft;
      };
      const maxIndex = () => {
        const unit = step();
        return unit > 0 ? Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / unit)) : 0;
      };
      const current = () => {
        const unit = step();
        return unit > 0 ? Math.min(maxIndex(), Math.round(track.scrollLeft / unit)) : 0;
      };

      let animationId = null;
      const goTo = (index) => {
        if (animationId) cancelAnimationFrame(animationId);
        const from = track.scrollLeft;
        const to = Math.min(maxIndex(), Math.max(0, index)) * step();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.scrollLeft = to;
          updateDots();
          return;
        }
        const startedAt = performance.now();
        const ease = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        const frame = (now) => {
          const progress = Math.min(1, (now - startedAt) / config.speed);
          track.scrollLeft = from + (to - from) * ease(progress);
          if (progress < 1) {
            animationId = requestAnimationFrame(frame);
          } else {
            animationId = null;
          }
        };
        animationId = requestAnimationFrame(frame);
      };

      const updateDots = () => {
        if (!dotsBox) return;
        [...dotsBox.children].forEach((dot, index) => {
          const isActive = index === current();
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };
      const buildDots = () => {
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        for (let index = 0; index <= maxIndex(); index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rr-product-grid__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `${carousel.dataset.dotLabel} ${index + 1}`);
          dot.addEventListener('click', () => { goTo(index); scheduleAutoplay(); });
          dotsBox.append(dot);
        }
        const navigable = maxIndex() > 0;
        previous.hidden = !navigable;
        next.hidden = !navigable;
        dotsBox.hidden = !navigable;
        updateDots();
      };

      let timer = null;
      let visible = true;
      let hovering = false;
      const stopAutoplay = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      };
      const scheduleAutoplay = () => {
        stopAutoplay();
        if (!config.autoplay) return;
        timer = setTimeout(() => {
          if (visible && !hovering && !document.hidden) {
            const nextIndex = current() + 1;
            if (nextIndex > maxIndex()) {
              if (config.loop) goTo(0);
            } else {
              goTo(nextIndex);
            }
          }
          scheduleAutoplay();
        }, config.interval);
      };

      previous.addEventListener('click', () => { goTo(current() - 1); scheduleAutoplay(); });
      next.addEventListener('click', () => { goTo(current() + 1); scheduleAutoplay(); });
      let scrollFrame = null;
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => { scrollFrame = null; updateDots(); });
      });
      track.addEventListener('pointerdown', () => {
        if (animationId) cancelAnimationFrame(animationId);
        scheduleAutoplay();
      });
      if (config.pauseHover) {
        carousel.addEventListener('mouseenter', () => { hovering = true; });
        carousel.addEventListener('mouseleave', () => { hovering = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(carousel);
      }
      window.addEventListener('resize', buildDots);
      buildDots();
      scheduleAutoplay();
    };

    const initAll = () => document.querySelectorAll('.rr-product-grid-carousel').forEach(initProductCarousel);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const initSlider = (slider) => {
      if (slider.dataset.rrInit) return;
      slider.dataset.rrInit = '1';
      const track = slider.querySelector('.rr-slider__track');
      const dotsBox = slider.querySelector('.rr-slider__dots');
      const speedValue = parseFloat(slider.dataset.speed);
      const cfg = {
        autoplay: slider.dataset.autoplay === 'true',
        speed: (Number.isFinite(speedValue) ? Math.max(0, speedValue) : 0.6) * 1000,
        loop: slider.dataset.loop === 'true',
        pauseHover: slider.dataset.pauseHover === 'true',
        autoHide: slider.dataset.autoHide === 'true',
        thumbs: slider.dataset.thumbs === 'true'
      };
      // 全部が1画面に収まっていて動かす余地がない時は矢印を隠す（設定がオンの時だけ）
      const lockCheck = () => {
        slider.classList.toggle('is-locked', cfg.autoHide && track.scrollWidth <= track.clientWidth + 1);
      };
      const slides = () => [...track.children];
      // そのスライドが実際に表示している写真を取り出す（背景画像＝袋部品、img＝写真部品の両対応）
      const thumbImage = (slide) => {
        if (!slide) return '';
        const cands = [slide, ...slide.querySelectorAll('*')];
        for (const el of cands) {
          const bg = getComputedStyle(el).backgroundImage;
          if (bg && bg !== 'none' && bg.includes('url(')) return bg;
        }
        const im = slide.querySelector('img');
        return im && im.currentSrc ? 'url("' + im.currentSrc + '")' : '';
      };
      const step = () => {
        const s = slides();
        if (s.length < 2) return track.clientWidth;
        return s[1].offsetLeft - s[0].offsetLeft;
      };
      const maxIndex = () => Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      const current = () => Math.min(maxIndex(), Math.round(track.scrollLeft / step()));

      let animId = null;
      const goTo = (i) => {
        if (animId) cancelAnimationFrame(animId);
        const from = track.scrollLeft;
        const to = Math.min(maxIndex(), Math.max(0, i)) * step();
        if (cfg.speed === 0) {
          track.scrollLeft = to;
          return;
        }
        const start = performance.now();
        const ease = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        const frame = (now) => {
          const p = Math.min(1, (now - start) / cfg.speed);
          track.scrollLeft = from + (to - from) * ease(p);
          if (p < 1) {
            animId = requestAnimationFrame(frame);
          } else {
            animId = null;
          }
        };
        animId = requestAnimationFrame(frame);
      };

      let timer = null;
      let visible = true;
      let hovering = false;
      const intervalMs = () => {
        const isSp = window.matchMedia('(max-width: 749px)').matches;
        const seconds = parseFloat(isSp ? slider.dataset.intervalSp : slider.dataset.interval);
        return (Number.isFinite(seconds) ? seconds : 3) * 1000;
      };
      const stopAuto = () => { if (timer) { clearTimeout(timer); timer = null; } };
      const scheduleAuto = () => {
        stopAuto();
        if (!cfg.autoplay) return;
        timer = setTimeout(() => {
          if (visible && !hovering && !document.hidden) {
            const next = current() + 1;
            if (next > maxIndex()) {
              if (cfg.loop) goTo(0);
            } else {
              goTo(next);
            }
          }
          scheduleAuto();
        }, intervalMs());
      };

      const buildDots = () => {
        lockCheck();
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        const count = maxIndex() + 1;
        const list = slides();
        for (let i = 0; i < count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = cfg.thumbs ? 'rr-slider__thumb' : 'rr-slider__dot';
          b.setAttribute('aria-label', (i + 1) + '枚目へ');
          if (cfg.thumbs) {
            const img = thumbImage(list[i]);
            if (img) b.style.backgroundImage = img;
          }
          b.addEventListener('click', () => { goTo(i); scheduleAuto(); });
          dotsBox.append(b);
        }
        update();
      };

      const update = () => {
        if (!dotsBox) return;
        [...dotsBox.children].forEach((d, i) => d.classList.toggle('is-active', i === current()));
      };

      slider.querySelector('.rr-slider__arrow--prev').addEventListener('click', () => { goTo(current() - 1); scheduleAuto(); });
      slider.querySelector('.rr-slider__arrow--next').addEventListener('click', () => { goTo(current() + 1); scheduleAuto(); });

      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = null; update(); });
      });
      track.addEventListener('pointerdown', () => { if (animId) cancelAnimationFrame(animId); scheduleAuto(); });
      if (cfg.pauseHover) {
        slider.addEventListener('mouseenter', () => { hovering = true; });
        slider.addEventListener('mouseleave', () => { hovering = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(slider);
      }
      window.addEventListener('resize', buildDots);
      buildDots();
      scheduleAuto();
    };

    const initAll = () => document.querySelectorAll('.rr-slider').forEach(initSlider);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', (e) => {
      const track = e.target.closest && e.target.closest('.rr-slider__track');
      if (track && e.target.parentElement === track) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
